// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__uWC3q","inputWrap":"CustomTip_inputWrap__3khxo"};